var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import { render, unmount } from "./utils";
import classNames from "classnames";
import { CSSMotionList } from "rc-motion";
import Notice from "./Notice";
import useNotification from "./useNotification";
export var prefixCls = "mex-notification";
var seed = 0;
var now = Date.now();
var getUuid = function () {
    var id = seed;
    seed += 1;
    return "mexNotification_".concat(now, "_").concat(id);
};
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            notices: [],
        };
        /**
         * @private Internal props do not call it directly.
         * We do not make this as private is caused TS will trade private as
         * different prop that between es and lib
         */
        _this.hookRefs = new Map();
        _this.add = function (originNotice, holderCallback) {
            var _a;
            var key = (_a = originNotice.key) !== null && _a !== void 0 ? _a : getUuid();
            var notice = __assign(__assign({}, originNotice), { key: key });
            var maxCount = _this.props.maxCount;
            _this.setState(function (previousState) {
                var notices = previousState.notices;
                var noticeIndex = notices.map(function (v) { return v.notice.key; }).indexOf(key);
                var updatedNotices = notices.concat();
                if (noticeIndex !== -1) {
                    updatedNotices.splice(noticeIndex, 1, { notice: notice, holderCallback: holderCallback });
                }
                else {
                    if (maxCount && notices.length >= maxCount) {
                        // XXX, use key of first item to update new added (let React to move exsiting
                        // instead of remove and mount). Same key was used before for both a) external
                        // manual control and b) internal react 'key' prop , which is not that good.
                        // eslint-disable-next-line no-param-reassign
                        // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
                        // Change to `updateMark` for compare instead.
                        // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
                        notice.key = updatedNotices[0].notice.key;
                        notice.updateMark = getUuid();
                        // zombieJ: That's why. User may close by key directly.
                        // We need record this but not re-render to avoid upper issue
                        // https://github.com/react-component/notification/issues/129
                        notice.userPassKey = key;
                        updatedNotices.shift();
                    }
                    updatedNotices.push({ notice: notice, holderCallback: holderCallback });
                }
                return {
                    notices: updatedNotices,
                };
            });
        };
        _this.remove = function (removeKey) {
            _this.setState(function (_a) {
                var notices = _a.notices;
                return ({
                    notices: notices.filter(function (_a) {
                        var _b = _a.notice, key = _b.key, userPassKey = _b.userPassKey;
                        var mergedKey = userPassKey !== null && userPassKey !== void 0 ? userPassKey : key;
                        return mergedKey !== removeKey;
                    }),
                });
            });
        };
        _this.noticePropsMap = {};
        return _this;
    }
    Notification.prototype.getTransitionName = function () {
        var _a = this.props, prefixCls = _a.prefixCls, animation = _a.animation;
        var transitionName = this.props.transitionName;
        if (!transitionName && animation) {
            transitionName = "".concat(prefixCls, "-").concat(animation);
        }
        return transitionName;
    };
    Notification.prototype.render = function () {
        var _this = this;
        var notices = this.state.notices;
        var _a = this.props, prefixCls = _a.prefixCls, className = _a.className, closeIcon = _a.closeIcon, style = _a.style;
        var noticeKeys = [];
        notices.forEach(function (_a, index) {
            var notice = _a.notice, holderCallback = _a.holderCallback;
            var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
            var key = notice.key, userPassKey = notice.userPassKey;
            var noticeProps = __assign(__assign(__assign({ prefixCls: prefixCls, closeIcon: closeIcon }, notice), notice.props), { key: key, noticeKey: userPassKey || key, updateMark: updateMark, onClose: function (noticeKey) {
                    var _a;
                    _this.remove(noticeKey);
                    (_a = notice.onClose) === null || _a === void 0 ? void 0 : _a.call(notice);
                }, onClick: notice.onClick, children: notice.content });
            // Give to motion
            noticeKeys.push(key);
            _this.noticePropsMap[key] = { props: noticeProps, holderCallback: holderCallback };
        });
        return (_jsx("div", __assign({ className: classNames(prefixCls, className), style: style }, { children: _jsx(CSSMotionList, __assign({ keys: noticeKeys, motionName: this.getTransitionName(), onVisibleChanged: function (changedVisible, _a) {
                    var key = _a.key;
                    if (!changedVisible) {
                        delete _this.noticePropsMap[key];
                    }
                } }, { children: function (_a) {
                    var key = _a.key, motionClassName = _a.className, motionStyle = _a.style, visible = _a.visible;
                    var _b = _this.noticePropsMap[key], noticeProps = _b.props, holderCallback = _b.holderCallback;
                    if (holderCallback) {
                        return (_jsx("div", { className: classNames(motionClassName, "".concat(prefixCls, "-hook-holder")), style: __assign({}, motionStyle), ref: function (div) {
                                if (typeof key === "undefined") {
                                    return;
                                }
                                if (div) {
                                    _this.hookRefs.set(key, div);
                                    holderCallback(div, noticeProps);
                                }
                                else {
                                    _this.hookRefs.delete(key);
                                }
                            } }, key));
                    }
                    return (_jsx(Notice, __assign({}, noticeProps, { className: classNames(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className), style: __assign(__assign({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style), visible: visible })));
                } })) })));
    };
    Notification.defaultProps = {
        prefixCls: prefixCls,
        animation: "fade",
        style: {
            top: 65,
            left: "50%",
        },
    };
    return Notification;
}(Component));
Notification.newInstance = function newNotificationInstance(properties, callback) {
    var _a = properties || {}, getContainer = _a.getContainer, props = __rest(_a, ["getContainer"]);
    var div = document.createElement("div");
    if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
    }
    else {
        document.body.appendChild(div);
    }
    var called = false;
    function ref(notification) {
        if (called) {
            return;
        }
        called = true;
        callback({
            notice: function (noticeProps) {
                notification.add(noticeProps);
            },
            removeNotice: function (key) {
                notification.remove(key);
            },
            component: notification,
            destroy: function () {
                unmount(div);
                if (div.parentNode) {
                    div.parentNode.removeChild(div);
                }
            },
            // Hooks
            useNotification: function () {
                return useNotification(notification);
            },
        });
    }
    // Only used for test case usage
    if (process.env.NODE_ENV === "test" && properties.TEST_RENDER) {
        properties.TEST_RENDER(_jsx(Notification, __assign({}, props, { ref: ref })));
        return;
    }
    render(_jsx(Notification, __assign({}, props, { ref: ref })), div);
};
export default Notification;
